const CONFIRM_MODAL_EMPTY_STATE = {
  open: false,
  onConfirm: () => {},
  onClose: () => {},
  title: '',
  message: null,
  cancelLabel: '',
  confirmLabel: '',
};

export default CONFIRM_MODAL_EMPTY_STATE;
